import React from "react";
import DeleteBin from "assets/svg/DeleteBin";

const DeleteButton = ({onClick}) => {

  return (
    <button
      className="flex border items-center text-red-600 hover:bg-red-600 hover:text-white font-semibold py-2 px-5 rounded-md gap-3"
      onClick={onClick}
    >
      <DeleteBin /> Delete
    </button>
  );
};

export default DeleteButton;
